module.exports = __webpack_public_path__ + "static/img/16.3195c9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/16.png
// module id = srtT
// module chunks = 0